import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="mt-8 border-t border-[#E5E7EB] bg-white px-4 py-4 text-center text-xs text-[#6B7280] sm:px-6"
      data-testid="app-footer"
    >
      © 2026 Maven Pharma S.r.l. ·{" "}
      <Link
        to="/privacy-policy"
        className="font-semibold text-[#0153A3] hover:underline"
        data-testid="footer-privacy-link"
      >
        Informativa Privacy
      </Link>
    </footer>
  );
}
